import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { Box, Typography, useTheme } from '@mui/material';

import PoweredBySparkl from '../PoweredBySparkl';
import { ThemeContext } from '../../globalContext/theme/themeProvider';
import { useBrandLegalUrls } from '../../hooks/useBrandLegalUrls';
import { styles } from './FooterStyles';

const Footer = () => {
  const theme = useTheme();
  const [themeState] = useContext(ThemeContext);
  const isHaleBrand = themeState?.brand?.key === 'hale';
  const classes = styles(theme, isHaleBrand);
  const { t } = useTranslation();
  const { termsUrl, privacyUrl } = useBrandLegalUrls();

  return (
    <Box sx={classes.termsAndConditionsBox}>
      <Box sx={classes.linksGroup}>
        <Typography
          sx={classes.link}
          onClick={() => {
            window.open(termsUrl);
          }}
        >
          {t('generic.terms')}
        </Typography>
        <Typography
          sx={classes.link}
          onClick={() => {
            window.open(privacyUrl);
          }}
        >
          {t('generic.privacyPolicy')}
        </Typography>
      </Box>
      {isHaleBrand && (
        <Box sx={classes.poweredByGroup}>
          <PoweredBySparkl onDarkBackground />
        </Box>
      )}
    </Box>
  );
};

export default Footer;